import { useState } from 'react';

const SkillInput = ({ label, skills, onChange, placeholder }) => {
  const [input, setInput] = useState('');

  const addSkill = () => {
    const trimmed = input.trim();
    if (trimmed && !skills.includes(trimmed)) {
      onChange([...skills, trimmed]);
    }
    setInput('');
  };

  const removeSkill = (skill) => onChange(skills.filter(s => s !== skill));

  const handleKey = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addSkill();
    }
    if (e.key === 'Backspace' && !input && skills.length > 0) {
      removeSkill(skills[skills.length - 1]);
    }
  };

  return (
    <div className="form-group">
      {label && <label className="form-label">{label}</label>}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
        padding: '8px 10px',
        border: '1.5px solid var(--gray-200)',
        borderRadius: 'var(--radius-sm)',
        background: 'var(--white)',
        minHeight: 44,
        cursor: 'text',
        transition: 'border-color 0.2s, box-shadow 0.2s',
      }}
        onClick={e => e.currentTarget.querySelector('input')?.focus()}
      >
        {skills.map((skill, i) => (
          <span key={i} className="tag" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            {skill}
            <button
              type="button"
              onClick={() => removeSkill(skill)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', padding: 0, lineHeight: 1, fontSize: 12 }}
            >✕</button>
          </span>
        ))}
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKey}
          onBlur={addSkill}
          placeholder={skills.length === 0 ? (placeholder || 'Type and press Enter') : ''}
          style={{
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            flex: 1,
            minWidth: 120,
            padding: '2px 4px',
            background: 'transparent',
            fontSize: 14
          }}
        />
      </div>
      <span className="form-hint">Press Enter or comma to add each skill</span>
    </div>
  );
};

export default SkillInput;
